import Cookies from 'js-cookie'
import { fetchPaymentApplyPendingCount } from '@/api/finPaymentApplication'
import { fetchApPendingCount } from '@/api/finSettlement'
import { fetchHoldCancellationTodayCount } from '@/api/hotelOrder'

const app = {
  state: {
    sidebar: {
      opened: !+Cookies.get('sidebarStatus'),
      withoutAnimation: false
    },
    device: 'desktop',
    /** 付款申请待审核条数（侧栏角标） */
    paymentApplyPendingCount: 0,
    /** 应付款管理未结清条数（侧栏角标） */
    apPendingCount: 0,
    /** Hold 房单今日取消提醒条数（侧栏角标：非已售、非已取消、取消日期为今天） */
    holdCancellationTodayCount: 0
  },
  mutations: {
    TOGGLE_SIDEBAR: state => {
      if (state.sidebar.opened) {
        Cookies.set('sidebarStatus', 1)
      } else {
        Cookies.set('sidebarStatus', 0)
      }
      state.sidebar.opened = !state.sidebar.opened
    },
    CLOSE_SIDEBAR: (state, withoutAnimation) => {
      Cookies.set('sidebarStatus', 1)
      state.sidebar.opened = false
      state.sidebar.withoutAnimation = withoutAnimation
    },
    TOGGLE_DEVICE: (state, device) => {
      state.device = device
    },
    SET_PAYMENT_APPLY_PENDING_COUNT: (state, n) => {
      const v = Number(n)
      state.paymentApplyPendingCount = Number.isFinite(v) && v >= 0 ? Math.floor(v) : 0
    },
    SET_AP_PENDING_COUNT: (state, n) => {
      const v = Number(n)
      state.apPendingCount = Number.isFinite(v) && v >= 0 ? Math.floor(v) : 0
    },
    SET_HOLD_CANCELLATION_TODAY_COUNT: (state, n) => {
      const v = Number(n)
      state.holdCancellationTodayCount = Number.isFinite(v) && v >= 0 ? Math.floor(v) : 0
    }
  },
  actions: {
    ToggleSideBar: ({ commit }) => {
      commit('TOGGLE_SIDEBAR')
    },
    CloseSideBar({ commit }, { withoutAnimation }) {
      commit('CLOSE_SIDEBAR', withoutAnimation)
    },
    ToggleDevice({ commit }, device) {
      commit('TOGGLE_DEVICE', device)
    },
    FetchPaymentApplyPendingCount({ commit }) {
      return fetchPaymentApplyPendingCount()
        .then(res => {
          const d = res && res.data != null ? res.data : 0
          commit('SET_PAYMENT_APPLY_PENDING_COUNT', d)
        })
        .catch(() => {})
    },
    FetchApPendingCount({ commit }) {
      return fetchApPendingCount()
        .then(res => {
          const d = res && res.data != null ? res.data : 0
          commit('SET_AP_PENDING_COUNT', d)
        })
        .catch(() => {})
    },
    FetchHoldCancellationTodayCount({ commit }) {
      return fetchHoldCancellationTodayCount()
        .then(res => {
          const d = res && res.data != null ? res.data : 0
          commit('SET_HOLD_CANCELLATION_TODAY_COUNT', d)
        })
        .catch(() => {})
    }
  }
}

export default app



// WEBPACK FOOTER //
// ./src/store/modules/app.js